
<div class="header">
    <h3 mat-dialog-title>Please select an Offer to link to this Margin</h3>
    <em (click)="closeDialog()" class="material-icons">
        close
    </em>
</div>
<div class="nova-grid-container">
    <nova-grid #grid
                [data]="data$ | async"
                [isLoading]="isLoading"
                [args]="fetchArgs$ | async"
                (dataNeeded)="load($event)"
                [autoFitColumns]="false"
                [singleSelection]="true"
                [resizable]="true"
                [filterable]="true"
                [reorderable]="true"
                [needToolbar]="false"
                (rowSelected)="rowSelected($event)"
                [selectable]="{ enabled: true, mode: 'single' }"
                [noRecordsMessage] = "noRecordsMessage">
        <nova-grid-column field="id" title="Offer Id" [template]="actionTemplate">
            <ng-template #actionTemplate let-dataItem="dataItem">
                <a class="nova__link" target="_blank" href="/#/recruiting/deals/{{dataItem.id}}">
                    {{ dataItem?.id }}
                </a>
            </ng-template>
        </nova-grid-column>
        <nova-grid-column field="contractType" title="Contract Type">
        </nova-grid-column>
        <nova-grid-column field="jobId" title="Job Id" [sortable]="true" filterType="text" [template]="jobIdTemplate" [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="jobIdFilterCellTemplate">
            <ng-template #jobIdTemplate let-dataItem="dataItem">
                <a class="nova__link" target="_blank" href="/#/recruiting/jobs/{{dataItem?.jobId}}">
                    {{ dataItem.jobId }}
                </a>
            </ng-template>
            <ng-template let-filterService="filterService" #jobIdFilterCellTemplate let-filter="filter">
                <grid-filter-layout>
                    <ng-template #quickFilter>
                        <grid-text-filter #jobIdFilter field="jobId" [filter]="filter" [filterService]="filterService"
                            class="app-nova-grid-text-filter"></grid-text-filter>
                    </ng-template>
                    <ng-template #popupFilter>
                        <grid-clear-filter-popup title="Job Id" field="jobId" [filter]="filter"
                            [filterService]="filterService"></grid-clear-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>
        <nova-grid-column field="facilityName"
                            title="Facility"
                            [sortable]="true"
                            [template]="facilityTemplate"
                            [filterTemplate]="emptyFilterTemplate" 
                            [filterCellTemplate]="facilityNameFilterCellTemplate"
                            filterType="text">
            <ng-template #facilityTemplate let-dataItem="dataItem">
                <a class="nova__link facility-link" target="_blank" href="/#/recruiting/facilities/{{dataItem.facilityId}}/facility-profile">
                    {{ dataItem?.facilityName }}
                </a>
            </ng-template>
            <ng-template let-filterService="filterService" #facilityNameFilterCellTemplate let-filter="filter">
                <grid-filter-layout>
                    <ng-template #quickFilter>
                        <grid-text-filter #facilityNameFilter field="facilityName" [filter]="filter" [filterService]="filterService"
                            class="app-nova-grid-text-filter"></grid-text-filter>
                    </ng-template>
                    <ng-template #popupFilter>
                        <grid-clear-filter-popup title="Title" field="facilityName" [filter]="filter"
                            [filterService]="filterService"></grid-clear-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>
        <nova-grid-column field="profession"
                            title="Profession"
                            [sortable]="true"
                            filterType="dropdown"
                            defaultItemText="All Professions"
                            textField="name"
                            valueField="id"
                            [filterOptions]="lookupProfessions">
        </nova-grid-column>
        <nova-grid-column field="expertise"
                            title="Specialty"
                            [sortable]="true"
                            filterType="dropdown"
                            defaultItemText="All Specialties"
                            textField="name"
                            valueField="searchableVal"
                            [filterOptions]="lookupExpertise">
        </nova-grid-column>
        <nova-grid-column field="startDate" title="Start Date" [template]="startDateTemplate">
            <ng-template #startDateTemplate let-dataItem="dataItem">
                {{ dataItem.startDate | date: 'MM/dd/yyyy' }}
            </ng-template>
        </nova-grid-column>
        <nova-grid-column field="accountManagerName" title="AM">
        </nova-grid-column>
        <nova-grid-column field="offerStatus"
                            title="Offer Status"
                            textField="name"
                            valueField="id">
        </nova-grid-column>
        <nova-grid-column field="updatedDateUtc" 
                    title="Offer Status Date" 
                    [template]="updatedDateUtcTemplate">
            <ng-template #updatedDateUtcTemplate let-dataItem="dataItem">
                {{ dataItem.updatedDateUtc | date: 'MM/dd/yyyy hh:mm a' | lowercase }}
            </ng-template>
        </nova-grid-column>
        <ng-template #emptyFilterTemplate></ng-template>
    </nova-grid>
</div>
<div class="action-btn-container">
    <button mat-flat-button (click)="linkMarginToOffer()"
        [disabled]="isLinkMarginButtonDisabled || isLinking"
        class="next-btn next-btn--margin-right"
        color="primary">
        <span>LINK OFFER</span>
    </button>
    <a class="nova__link" (click)="closeDialog(0)">Continue without linking</a>
</div>
